/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import BarraPc from "./BarraPc";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {CONTACTOS, REDES} from "../../Constantes";
import {LocationPin} from '@mui/icons-material'
import {irUrl} from "../../Utilidades/irUrl";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import BarraCell from "./BarraCell";

const Barra = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#000',
                    px: 3,
                    py: sCell ? 0 : 0.5
                }}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 4}}>

                    {!sCell && REDES.map((item, index) => (
                        <IconButton
                            onClick={() => irUrl(item.url)}
                        >
                            <img src={item.img} style={{width: 24, height: 24}}/>
                        </IconButton>
                    ))}

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'center'}}>
                    <Splide
                        aria-label="My Favorite Images"
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            arrows: false,
                            pagination: false,
                            width: '100%',
                            drag: false,
                            interval: 5000,
                            noDrag: true,
                            type: 'loop',
                            direction: 'ttb', // Configuración clave para orientación vertical (top to bottom)
                            height: 40, // Es obligatorio definir una altura para el carrusel vertical
                            wheel: true,


                        }}
                    >

                        {items.map((item, index) => {
                            return (
                                <SplideSlide key={`qe${index}`}>
                                    <Typography
                                        onClick={() => item.url ? irUrl(item.url) : ''}
                                        sx={{
                                            color: '#fff',
                                            mt: 0.5,
                                            cursor: 'pointer',
                                            borderBottom: 1,
                                            borderColor: '#ffffff00',
                                            transition: 'all 0.2s ease-in-out',
                                            "&:hover": {
                                                borderColor: '#ffff',
                                            }
                                        }}
                                    >{item}</Typography>
                                </SplideSlide>
                            )
                        })}


                    </Splide>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-end', mt: -0.3}}>
                    {!sCell &&

                        <Typography
                            onClick={() => irUrl(CONTACTOS[0].url)}
                            sx={{
                                color: '#fff',
                                fontSize: 12,
                                transition: 'all 0.2s ease-in-out',
                                cursor: 'pointer',
                                borderBottom: 1,
                                borderColor: '#ffffff00',
                                "&:hover": {
                                    borderColor: '#ffff',
                                }
                            }}>
                            <LocationPin sx={{
                                fill: '#fff', width: 18, height: 'auto', pr: 0.5, mt: 0.5, mb: -0.5,

                            }}/>
                            {CONTACTOS[0].descripcion}
                        </Typography>
                    }
                </Grid>


            </Grid>

            {sCell ?

                <BarraCell/>
                :
                <BarraPc/>
            }


        </Grid>
    )

}
export default Barra

const items = [
    'Estilo + Salud Visual', 'Ofertas Exclusivas'
]

